module.exports = __webpack_public_path__ + "static/113-590d368a2a21f41768e9cc72f2c026ce.png";